import { Image as ImageIcon } from 'lucide-react';
import type { Campaign } from '../campaignsApi';
import { googleCampaignDestination } from '../campaignCardPolicy';
import { CampaignDestinationPreview } from './CampaignDestinationPreview';
import './campaign-card-media.css';

export function CampaignCardMedia({ campaign }: { campaign: Campaign }) {
  const image = campaign.primary_asset_url || campaign.creatives?.find(creative => creative.asset_url)?.asset_url;
  const destination = googleCampaignDestination(campaign);
  return <>
    {image && <div className="campaign-card-art"><img src={image} alt={`Arte de ${campaign.name}`} loading="lazy" /></div>}
    {destination && <CampaignDestinationPreview campaignId={campaign.id} url={destination} />}
    {!image && !destination && <div className="campaign-card-art campaign-card-art-empty"><ImageIcon size={24} /></div>}
  </>;
}
